export class LocalStorageConfig {
	storageType: "local" | "session";
}
